import type { PageNotice } from './pageNotice';

export function PageNoticePanel({ notices }: { notices: readonly PageNotice[] }) {
    if (notices.length === 0) return null;
    return (
        <section className="space-y-2" aria-live="polite">
            <h2 className="text-sm font-semibold">Resultados</h2>
            <ul className="space-y-2">
                {notices.map((notice) => (
                    <li
                        key={notice.id}
                        className={
                            notice.type === 'err'
                                ? 'rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-200'
                                : 'rounded-lg border border-border bg-muted/40 px-3 py-2 text-sm'
                        }
                    >
                        {notice.text}
                    </li>
                ))}
            </ul>
        </section>
    );
}
